import script from "./PageToolbarHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageToolbarHeader.vue?vue&type=script&lang=ts&setup=true"

import "./PageToolbarHeader.vue?vue&type=style&index=0&id=f94262ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f94262ac"]])

export default __exports__